import { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { getAuth } from 'firebase/auth';

import { redirecturlQueryParam } from '../app/constants/constants';
import { useAppDispatch, useAppSelector } from '../app/store/hooks';
import { emailAuthCheckCall } from '../components/authentication/auth.thunk';
import { useUpAuth } from '../components/authentication/UpAuth';
import { ErrorManagementContext } from '../utils/errorManagement/ErrorManagementProvider';
import { logEvents } from '../utils/logging';
import styles from "./emailCheck.module.css";

const EmailCheck = () => {

  const history = useHistory();

  const dispatch = useAppDispatch();

  const [email, setEmail] = useState('');
  const [userName, setUserName] = useState('');

  const { logout } = useUpAuth()

  const { cookClubLog } = useContext(ErrorManagementContext);

  const phone = useAppSelector(state => state.auth.otpLogin.phone);
  const redirecturl = useAppSelector(state => state.auth.redirectParam)
  const isEmailNameSubmitLoading = useAppSelector(state => state.auth.loaders.isEmailNameSubmitLoading);
  const userHasuraID = useAppSelector(state => state.auth.userHasuraID)

  const handleSubmit = async () => {
    const auth = getAuth();
    const fireBaseJWTMob = await auth.currentUser?.getIdToken() ?? null;
    const fireBaseUserId = auth.currentUser?.uid ?? null;
    try {
      await dispatch(emailAuthCheckCall({ userName, email, phone, fireBaseJWTMob, fireBaseUserId, cookClubLog }))
      logEvents('null', 'APP_USER_LOGGED_IN', {
        userId: userHasuraID,
      })

      history.push(`${redirecturl}`)
    } catch (e) {
      logout()
      history.push(`sign-in/?${redirecturlQueryParam}=${redirecturl}`)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.sub_container}>
        <Typography variant='h6'>
          Help us get to know you
        </Typography>
        <div className={styles.text_field_container}>
          <div className={styles.text_field}>
            <TextField
              id="outlined-basic"
              onChange={(e) => setUserName(e.target.value)}
              placeholder='Name'
              value={userName}
              variant="outlined"
            />
            {/* {userName.length === 0 && <Typography style={{ color: '#FF0000' }} variant='caption4Light'>Please provide your name</Typography>} */}
          </div>
          <div className={styles.text_field_existing}>
            <TextField
              id="outlined-basic"
              onChange={(e) => setEmail(e.target.value)}
              placeholder='Email ID'
              type='email'
              value={email}
              variant="outlined"
            />
            <Typography variant='caption3Light'>Provide the existing Email ID if you already have an upliance account</Typography>
          </div>
          <Button className={userName.length ? styles.submit_button : styles.disabled_submit_button} disabled={!userName} onClick={handleSubmit}>
            <Typography variant='caption3Light'>Submit</Typography>
            {isEmailNameSubmitLoading && <div className={styles.progress_container}><CircularProgress className={styles.progress_loader} size={17} /></div>}
          </Button>
        </div>
      </div >
    </div >
  )
}

export default EmailCheck